<template>
  <b-form-group
    class="mypoda-form-field"
    :class="{ 'mypoda-form-field--invalid': hasError }"
  >
    <label
      v-if="label"
      :for="inputId"
      class="mypoda-field-label"
    >
      {{ label }}<span
        v-if="requiredMark"
        class="text-danger"
      >*</span>
    </label>
    <validation-provider
      #default="{ errors }"
      :name="name"
      :rules="rules"
      :vid="vid || name"
    >
      <div class="mypoda-field-control">
        <slot
          :errors="errors"
          :state="fieldState(errors)"
          :input-id="inputId"
        />
        <small
          v-if="errors[0]"
          class="mypoda-field-error"
        >{{ errors[0] }}</small>
      </div>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { BFormGroup } from 'bootstrap-vue'
import { ValidationProvider } from 'vee-validate'

let fieldId = 0

export default {
  name: 'MypodaFormField',
  components: {
    BFormGroup,
    ValidationProvider,
  },
  props: {
    label: { type: String, default: '' },
    name: { type: String, required: true },
    rules: { type: [String, Object], default: '' },
    vid: { type: String, default: '' },
    requiredMark: { type: Boolean, default: false },
  },
  data() {
    fieldId += 1
    return {
      inputId: `mypoda-field-${fieldId}`,
    }
  },
  methods: {
    fieldState(errors) {
      return errors && errors.length ? false : null
    },
  },
}
</script>
